import Ajax from '../ajax'

export default {
  postOrder: (data) => Ajax('post', 'front/order/confirm', data),
  orders: (params) => Ajax('get', 'front/order/list', params),
  checkOrderArrivals: (params) => Ajax('get', 'front/order/finished', params),
  payOrder: (params) => Ajax('get', 'front/payment/order', params)
}
